import styled from 'styled-components';
import { media } from 'src/ui/common/mixins/media';

export const StyledLabel = styled.div`
  display: inline-flex;
  background-color: ${({ theme }) => theme.colors.gs500};
  border: ${({ theme }) => `1px solid ${theme.colors.gs400}`};
  border-radius: 5px;
  padding: 6px;
  font-size: 14px;
  width: min-content;
  align-items: center;
  height: 30px;

  ${media.sm`
    font-size: 16px;
    padding: 8px;
  `}

  > * {
    &:nth-child(1n) {
      margin-left: 6px;
      
      ${media.sm`
        margin-left: 8px;
    `}
    }
  }
`;

